import { mapState } from "vuex";
import MixpanelEvents from "@/constants/events";

import data from "@/mixins/data";
import formable from "@/mixins/formable";
import prices from "@/pages/reservations/mixins/prices";

import {
  GET_PROPERTIES_LIST,
} from "@/store/properties/actions";

import {
  REPLACE_RESERVATIONS,
  DELETE_SPLIT_RESERVATIONS
} from "@/store/reservations/actions";

import {
  GET_RATE_CALENDAR_COLLECTION
} from "@/store/rate-calendar/actions";

import VClient from "@/components/widgets/VClient";

export default {
  mixins: [
    data,
    formable,
    prices,
  ],
  components: {
    VClient,
  },
  props: {
    options: {
      type: Object,
      required: false,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      form: {
        type: 1,
        end_date: null,
        start_date: null,
        expired_at: null,
        discount: null,
        children: null,
        children_ages: [],
      },
      startDate: {
        menu: false,
        formatted: null
      },
      endDate: {
        menu: false,
        formatted: null
      },
      isOpenCancellation: false,
      isOpenForceDelete: false,
      isOpenConvert: false,
      isOpenReplace: false,
      isOpenSplit: false,
      isOpenSplitDelete: false,
      isOpenDateChanged: false,
      amountRefreshing: false,
      replaceOptions: {},
      tabs: 'tab-main',
      deleteData: {
        skip_messages: 0
      },
      searchUnitsFilters: {}
    }
  },
  methods: {
    openConvert() {
      this.isOpenConvert = true;
    },
    openReplace(options) {
      this.isOpenReplace = true;
      this.replaceOptions = options;
    },
    openCancellation() {
      this.isOpenCancellation = true;
    },
    openForceDelete() {
      this.isOpenForceDelete = true;
    },
    openSplit() {
      this.isOpenSplit = true;
    },
    closeSplit() {
      this.isOpenSplit = false;
    },
    openSplitDelete() {
      this.isOpenSplitDelete = true;
    },
    closeSplitDelete() {
      this.isOpenSplitDelete = false;
    },
    getProperties() {
      this.$store.dispatch(GET_PROPERTIES_LIST, {
        order: 'asc',
        sortBy: 'name',
      });
    },
    searchUnits() {
      let filter = {
        order: 'asc',
        sortBy: 'name',
      };

      if (this.form.property_id) {
        filter.property_id = this.form.property_id;
      }
      if (this.form.room_type_id && !this.form.id) {
        filter.room_type_id = this.form.room_type_id;
      }
      if (this.form.end_date && this.form.start_date) {
        filter.available =  {
          end_date: this.form.end_date,
          start_date: this.form.start_date,
        };

        if (this.form.id) {
          filter.available.except = this.form.id;
        }
      }

      this.searchUnitsFilters = filter;
    },
    blockColor() {
      if (this.form.status === this.$const('ConstReservationStatuses', 'CANCELED')) return 'error';
      if (this.form.type === this.$const('ConstReservationTypes', 'OPTION')) return 'orange';
      if (this.form.type === this.$const('ConstReservationTypes', 'BLOCK')) return 'amber';
      if (this.form.status === this.$const('ConstReservationStatuses', 'PENDING')) return 'grey';

      return 'primary';
    },
    replaceReservation(options) {
      this.$store.dispatch(REPLACE_RESERVATIONS, {
        id: this.itemId,
        params: { ...options }
      }).then((response) => {
        this.$emit("success", response);
      });
    },
    successSplit(response) {
      this.success(response);
    },
    failedSplit(response) {
      this.error(response);
    },
    splitDelete(id) {
      this.$store.dispatch(DELETE_SPLIT_RESERVATIONS, {id}).then(() => {
        this.$monitorService.track(MixpanelEvents.RESERVATION_SPLIT_DELETE);
        this.closeSplitDelete();
        this.success(this.$lang('main.words.succeeded'));
      });
    },
    dateChanged() {
      this.isOpenDateChanged = true;
    },
    refreshAmount() {
      this.amountRefreshing = true;
      this.$store.dispatch(GET_RATE_CALENDAR_COLLECTION, {
        _data: {
          where: [
            {
              field: 'date',
              comparison: '>=',
              value: this.form.start_date
            },
            {
              field: 'date',
              comparison: '<',
              value: this.form.end_date
            },
            {
              field: 'room_type_id',
              comparison: '=',
              value: this.form.room_type_id
            },
          ]
        }
      }).then((response) => {
        if (!response.collection.length) {
          return;
        }

        let amount = 0;

        response.collection.map((rate) => {
          amount += parseFloat(rate.amount);
        })

        this.form.amount = amount.toFixed(2);
        this.amountRefreshing = false;
        this.isOpenDateChanged = false;
      });
    },
  },
  computed: {
    ...mapState({
      units: state => state.units.getCollectionRequest.collection,
      unitsRequest: state => state.units.getCollectionRequest,
      properties: state => state.properties.getListRequest.list,
      propertiesRequest: state => state.reservations.getListRequest,
      splitDeleteRequest: state => state.reservations.splitDeleteRequest,
    })
  },
  watch: {
    'form.property_id'(id, old) {
      if (!id || (this.form.id && !old) || this.options.property) {
        return false;
      }

      delete this.form['unit_id'];

      this.clients = [];

      this.searchUnits();
    },
    'form.end_date'(val) {
      if (this.form.property_id && !this.options.property) {
        this.searchUnits();
      }
    },
    'form.start_date'(val) {
      const startDate = this.$moment(this.form.start_date);

      if (!this.form.end_date) {
        this.form.end_date = this.$toDateString(startDate.add(1, 'days'));
        return;
      }

      const endDate = this.$moment(this.form.end_date);

      if (startDate.isSameOrAfter(endDate)) {
        this.form.end_date = this.$toDateString(startDate.add(1, 'days'));
      } else {
        if (this.form.property_id && !this.options.property) {
          this.searchUnits();
        }
      }
    },
  }
};
